import emptyStateImage from 'Assets/images/empy-states/empty-convertations-group.png';
import React from 'react';
import { EmptyState, EmptyStateProps } from '~/lib/ui/emptyState';
import { cn } from '~/lib/utils';

interface ConversationEmptyStateProps {
  isContactSelected: boolean;
  className?: string;
}

const emptyStateText: Omit<EmptyStateProps, 'illustration'> = {
  title: 'You’re starting a new conversation!',
  description: 'Type your first message below.',
  content: 'Say: hello',
};

export const ConversationEmptyState = ({
  isContactSelected = false,
  className,
}: ConversationEmptyStateProps) => {
  return (
    <div className={cn("grid grid-cols-1 justify-center h-full items-center", className)}>
      <EmptyState
        title={emptyStateText.title}
        description={isContactSelected && emptyStateText.description}
        content={isContactSelected && emptyStateText.content}
        illustration={<img className="max-w-[320px] h-auto w-auto" src={emptyStateImage} alt="empty state" />}
      />
    </div>
  );
};